import { useCheTheme } from '@/styles/themes';
export const GlobalStylesInjector = () => {
    const theme = useCheTheme();
    if (Object.keys(theme).length !== 0) {
        theme.useGlobalStyles();
    }
    return null;
};
